(function(){
  'use strict';

  var scheduled = false;
  var clarityObserver = null;
  var observedClarityRoot = null;
  var chatObserver = null;
  var observedChatRoot = null;
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var mobileRight = 16;
  var mobileSize = 52;
  var mobileGap = 12;
  var mobileBottom = 96;
  var controlledProperties = [
    'position',
    'top',
    'left',
    'right',
    'bottom',
    'width',
    'height',
    'min-width',
    'min-height',
    'max-width',
    'max-height',
    'margin',
    'overflow',
    'border-radius',
    'transform',
    'translate',
    'z-index',
    'pointer-events',
    'visibility',
    'opacity'
  ];
  var compactProperties = [
    'width',
    'height',
    'min-width',
    'min-height',
    'max-width',
    'max-height',
    'overflow',
    'border-radius'
  ];

  function setImportant(element, property, value){
    if(!element) return;
    if(element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important') return;
    element.style.setProperty(property, value, 'important');
  }

  function clearProperties(element, properties){
    if(!element) return;
    properties.forEach(function(property){
      element.style.removeProperty(property);
    });
  }

  function getClarityAgent(){
    var host = document.getElementById('ads-agent-host');
    if(!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('[aria-label="Shopping Agent"]');
  }

  function getClarityParts(agent){
    if(!agent) return null;
    return {
      agent:agent,
      button:agent.querySelector('[role="button"]')
    };
  }

  function isClarityOpen(parts){
    if(!parts || !parts.button) return false;
    return parts.button.getAttribute('aria-expanded') === 'true';
  }

  function setClarityCompact(parts, compact){
    if(!parts) return;

    var textNodes = parts.button
      ? parts.button.querySelectorAll('div, span, p')
      : [];
    Array.prototype.forEach.call(textNodes, function(element){
      var text = (element.textContent || '').trim();
      if(!text || element.children.length > 0) return;
      if(compact){
        setImportant(element, 'display', 'none');
        element.setAttribute('data-hitch-clarity-text', 'hidden');
      } else if(element.getAttribute('data-hitch-clarity-text') === 'hidden'){
        element.style.removeProperty('display');
        element.removeAttribute('data-hitch-clarity-text');
      }
    });

    if(parts.button){
      var animatedText = parts.button.querySelectorAll('div[class*="overflow-hidden"]');
      Array.prototype.forEach.call(animatedText, function(element){
        if(element.querySelector('svg, img, canvas')) return;
        if(compact){
          setImportant(element, 'display', 'none');
          element.setAttribute('data-hitch-clarity-wrap', 'hidden');
        } else if(element.getAttribute('data-hitch-clarity-wrap') === 'hidden'){
          element.style.removeProperty('display');
          element.removeAttribute('data-hitch-clarity-wrap');
        }
      });

      if(compact){
        setImportant(parts.button, 'width', mobileSize + 'px');
        setImportant(parts.button, 'height', mobileSize + 'px');
        setImportant(parts.button, 'min-width', mobileSize + 'px');
        setImportant(parts.button, 'border-radius', '999px');
        setImportant(parts.button, 'padding', '4px');
        setImportant(parts.button, 'gap', '0');
        setImportant(parts.button, 'justify-content', 'center');
      } else {
        clearProperties(parts.button, [
          'width',
          'height',
          'min-width',
          'border-radius',
          'padding',
          'gap',
          'justify-content'
        ]);
      }
    }

    if(compact){
      setImportant(parts.agent, 'width', mobileSize + 'px');
      setImportant(parts.agent, 'max-width', mobileSize + 'px');
      setImportant(parts.agent, 'height', mobileSize + 'px');
    } else {
      clearProperties(parts.agent, ['width', 'max-width', 'height']);
    }
  }

  function setGoogleCompact(element, compact){
    if(!element) return;
    var iframe = element.querySelector('iframe');
    var dimensions = ['width', 'height', 'min-width', 'min-height', 'max-width', 'max-height'];

    if(compact){
      dimensions.forEach(function(property){
        setImportant(element, property, mobileSize + 'px');
      });
      setImportant(element, 'overflow', 'hidden');
      setImportant(element, 'border-radius', '999px');
      if(iframe){
        ['width', 'height', 'max-width', 'max-height'].forEach(function(property){
          setImportant(iframe, property, mobileSize + 'px');
        });
      }
    } else {
      clearProperties(element, dimensions.concat(['overflow', 'border-radius']));
      clearProperties(iframe, ['width', 'height', 'max-width', 'max-height']);
    }
  }

  function chatRoot(chat){
    return chat && chat.shadowRoot ? chat.shadowRoot : chat;
  }

  function isChatOpen(chat){
    var root = chatRoot(chat);
    if(!root) return false;

    if(root.querySelector('[aria-expanded="true"]')) return true;
    if(root.querySelector(
      '[aria-label*="close" i], [title*="close" i], [data-testid*="close" i]'
    )) return true;

    var frames = root.querySelectorAll('iframe');
    for(var index = 0; index < frames.length; index += 1){
      var rect = frames[index].getBoundingClientRect();
      if(rect.width > 160 || rect.height > 160) return true;
    }

    return false;
  }

  function observeWidgetRoots(){
    if(!('MutationObserver' in window)) return;

    var clarityHost = document.getElementById('ads-agent-host');
    var clarityRoot = clarityHost && clarityHost.shadowRoot;
    if(clarityRoot && clarityRoot !== observedClarityRoot){
      if(clarityObserver) clarityObserver.disconnect();
      observedClarityRoot = clarityRoot;
      clarityObserver = new MutationObserver(scheduleArrange);
      clarityObserver.observe(clarityRoot, {
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:['style', 'class', 'aria-expanded']
      });
    }

    var chat = document.getElementById('ShopifyChat');
    var root = chatRoot(chat);
    if(root && root !== observedChatRoot){
      if(chatObserver) chatObserver.disconnect();
      observedChatRoot = root;
      chatObserver = new MutationObserver(scheduleArrange);
      chatObserver.observe(root, {
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:['style', 'class', 'aria-expanded', 'aria-hidden']
      });
    }
  }

  function placeWidget(element, right, bottom, zIndex, compact){
    if(!element) return;
    setImportant(element, 'position', 'fixed');
    setImportant(element, 'top', 'auto');
    setImportant(element, 'left', 'auto');
    setImportant(element, 'right', right + 'px');
    setImportant(element, 'bottom', bottom + 'px');
    setImportant(element, 'margin', '0');
    setImportant(element, 'transform', 'none');
    setImportant(element, 'translate', 'none');
    setImportant(element, 'z-index', String(zIndex));
    setImportant(element, 'pointer-events', 'auto');
    setImportant(element, 'visibility', 'visible');
    setImportant(element, 'opacity', '1');

    if(compact){
      setImportant(element, 'width', mobileSize + 'px');
      setImportant(element, 'height', mobileSize + 'px');
      setImportant(element, 'min-width', mobileSize + 'px');
      setImportant(element, 'min-height', mobileSize + 'px');
      setImportant(element, 'max-width', mobileSize + 'px');
      setImportant(element, 'max-height', mobileSize + 'px');
      setImportant(element, 'overflow', 'hidden');
      setImportant(element, 'border-radius', '999px');
    }
  }

  function hideWidget(element){
    if(!element) return;
    setImportant(element, 'pointer-events', 'none');
    setImportant(element, 'visibility', 'hidden');
    setImportant(element, 'opacity', '0');
  }

  function visibleHeight(element, fallback){
    if(!element) return fallback;
    var rect = element.getBoundingClientRect();
    if(rect.height <= 0) return fallback;
    return Math.min(Math.ceil(rect.height), 96);
  }

  function arrangeWidgets(){
    scheduled = false;
    observeWidgetRoots();

    var chat = document.getElementById('ShopifyChat');
    var clarity = getClarityAgent();
    var google = document.getElementById('google-merchantwidget-iframe-wrapper');
    if(!chat && !clarity && !google) return;

    var isMobile = mobileQuery.matches;
    var chatOpen = isChatOpen(chat);

    if(isMobile && chatOpen){
      clearProperties(chat, controlledProperties);
      hideWidget(clarity);
      hideWidget(google);
      return;
    }

    if(isMobile){
      var clarityParts = getClarityParts(clarity);
      var clarityOpen = isClarityOpen(clarityParts);

      if(chat){
        placeWidget(chat, mobileRight, mobileBottom, 9982, true);
      }

      if(clarity){
        setClarityCompact(clarityParts, !clarityOpen);
        placeWidget(
          clarity,
          mobileRight,
          mobileBottom + mobileSize + mobileGap,
          9981,
          !clarityOpen
        );
      }

      if(google){
        setGoogleCompact(google, true);
        placeWidget(
          google,
          mobileRight,
          mobileBottom + ((mobileSize + mobileGap) * 2),
          9980,
          true
        );
      }
      return;
    }

    clearProperties(chat, compactProperties);
    setClarityCompact(getClarityParts(clarity), false);
    setGoogleCompact(google, false);

    var right = 24;
    var gap = 12;
    var bottom = 24;

    if(chat){
      placeWidget(chat, right, bottom, 9982, false);
      bottom += visibleHeight(chat, 64) + gap;
    }
    if(clarity){
      placeWidget(clarity, right, bottom, 9981, false);
      bottom += visibleHeight(clarity, 60) + gap;
    }
    if(google){
      placeWidget(google, right, bottom, 9980, false);
    }
  }

  function scheduleArrange(){
    if(scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(arrangeWidgets);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', scheduleArrange, { once:true });
  } else {
    scheduleArrange();
  }

  window.addEventListener('load', scheduleArrange);
  window.addEventListener('resize', scheduleArrange, { passive:true });
  document.addEventListener('click', function(){
    window.setTimeout(scheduleArrange, 0);
    window.setTimeout(scheduleArrange, 150);
    window.setTimeout(scheduleArrange, 500);
  }, true);

  if(mobileQuery.addEventListener){
    mobileQuery.addEventListener('change', scheduleArrange);
  } else if(mobileQuery.addListener){
    mobileQuery.addListener(scheduleArrange);
  }

  if('MutationObserver' in window){
    var observer = new MutationObserver(function(){
      observeWidgetRoots();
      scheduleArrange();
    });
    observer.observe(document.documentElement, {
      childList:true,
      subtree:true
    });
  }

  window.setTimeout(scheduleArrange, 500);
  window.setTimeout(scheduleArrange, 1500);
  window.setTimeout(scheduleArrange, 3500);
})();
